import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";

export default function UnregisteredDriverModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">Жолооч олдсонгүй!</h4>
          <hr />
          <p className="mb-0">
            {props.phone} дугаартай жолооч бүртгэлгүй байна. Бүртгэх үү?
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <>
          <Button
            onClick={() => props.setShow(false)}
            className="btn btn-light border"
            type="submit"
          >
            <span>Хаах</span>
          </Button>
          <Button
            onClick={props.onSubmit}
            className="btn btn-success"
            type="submit"
          >
            <span>Бүртгэх</span>
          </Button>
        </>
      </Modal.Footer>
    </Modal>
  );
}
